module.exports = __webpack_public_path__ + "media/images/f_1-0ed611c80b371c0c00364626265a8e99.png";